import { action, API, controller } from "api";
import { InputDate } from "controls";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const InputFyDate = ({ values, setValues, errors, handleInpDate }) => {
  const { t } = useTranslation();
  const [lastClosingDate, setLastClosingDate] = useState(
    dayjs().add(-5, "year")
  );

  // Get last fiscal year closing date.
  useEffect(() => {
    !values.id &&
      API(controller.FiscalYear + action.LastFyClosingDate).get((res) => {
        if (res?.status === 200) {
          setLastClosingDate(res?.result);
          setValues((prev) => ({ ...prev, startDate: dayjs(res?.result) }));
        } else setValues((prev) => ({ ...prev, startDate: dayjs() }));
      });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // !values.id &&
    setValues((prev) => {
      var endDate = prev.startDate
        ? dayjs(prev.startDate).add(1, "year").toDate()
        : "";
      return {
        ...prev,
        endDate: prev.startDate
          ? dayjs(prev.startDate).add(1, "year").toDate()
          : "",
        title:
          endDate &&
          `Fiscal Year ${dayjs(prev.startDate).year()} - ${dayjs(
            endDate
          ).year()}`,
      };
    });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.startDate]);

  return (
    <div className="flex gap-3">
      <InputDate
        size="small"
        variant="outlined"
        label={t("startDate")}
        required
        name="startDate"
        error={errors.startDate}
        value={values.startDate}
        views={["day"]}
        openTo="day"
        minDate={lastClosingDate}
        maxDate={dayjs()}
        onChange={(date) =>
          handleInpDate(
            "startDate",
            date ? dayjs(date).format("DD/MMM/YYYY") : ""
          )
        }
      />
      <InputDate
        size="small"
        variant="outlined"
        label={t("endDate")}
        required
        name="endDate"
        error={errors.endDate}
        value={values.endDate}
        disabled
        minDate={
          values.startDate
            ? dayjs(values.startDate).add(1, "year").toDate()
            : ""
        }
        views={["day"]}
        openTo="day"
        onChange={(date) =>
          handleInpDate(
            "endDate",
            date ? dayjs(date).format("DD/MMM/YYYY") : ""
          )
        }
      />
    </div>
  );
};

export default InputFyDate;
